/**
 * Premium SaaS design tokens (Stripe / Linear / Vercel inspired).
 * 8px spacing base · single accent · neutral surfaces.
 */
const themeConfig = {
  mode: 'light',
  borderRadius: 12,
  borderRadiusLg: 16,
  fontFamily: '"Inter", "SF Pro Display", "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
  primaryColor: '#4F46E5',
  primaryDeep: '#4338CA',
  primarySoft: '#EEF2FF',
  primarySoftStrong: '#E0E7FF',
  secondaryColor: '#64748B',
  successColor: '#059669',
  warningColor: '#D97706',
  errorColor: '#DC2626',
  infoColor: '#4F46E5',
  canvasColor: '#EEF2FF',
  pageBackground: '#F8FAFC',
  surfaceSecondary: '#F1F5F9',
  borderColor: '#E2E8F0',
  borderLight: '#F1F5F9',
  borderInput: '#CBD5E1',
  textPrimary: '#0F172A',
  textSecondary: '#64748B',
  textMuted: '#94A3B8',
  textLabel: '#334155',
  accentSoft: '#EEF2FF',
  accentSoftStrong: '#E0E7FF',
  roseSoft: '#FEF2F2',
  roseBorder: '#FECACA',
  roseText: '#991B1B',
  roseIcon: '#DC2626',
  shadowSm: '0 1px 2px rgba(15, 23, 42, 0.05)',
  shadowMd: '0 4px 16px rgba(15, 23, 42, 0.06)',
  shadowLg: '0 12px 40px rgba(79, 70, 229, 0.12)',
  fieldHeight: 44,
  authCardRadius: 16,
  drawerWidth: 260,
  headerHeight: 64,
  contentMaxWidth: 1200,
  space: 8,
};

export default themeConfig;
